// export const phoneRegex1 = "^(0|33)[1-9][0-9]{8}$";
// export const phoneRegex2 = "^(?!.*(0|33)[1-9](\\d)\\2{7}).*$";
// export const phoneRegex3 = "^(?!.*(0|33)[1-9]((60606060)|(01020304)|(01000000)|(01010101)|(12345678))).*$";
export const emailRegex = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$|^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}$";
export const phoneRegex4 = "^(?:(?:\\+|00)33|0)\s*[1-9][0-9]{8}$";